import { toast } from "react-toastify";
import { HTTPURL } from "../../constants/Matcher";

const base = `${HTTPURL}api/branches`;

export async function event_list(branchId) {
  try {
    const res = await fetch(`${base}/event-list?branch_id=${branchId}`);
    return await res.json();
  } catch (e) {
    return { status: false, message: e.message, data: [] };
  }
}

export async function event_edit(id) {
  try {
    const res = await fetch(`${base}/event-edit?id=${id}`);
    return await res.json();
  } catch (e) {
    return { status: false, message: e.message };
  }
}

export async function event_add(payload) {
  try {
    const res = await fetch(`${base}/event-add`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });
    const data = await res.json();
    if (data?.status) toast.success(data?.message);
    else toast.error(data?.message);
    return data;
  } catch (e) {
    toast.error(e.message);
    return { status: false, message: e.message };
  }
}

export async function event_update(id, payload) {
  try {
    const res = await fetch(`${base}/event-update?id=${id}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });
    const data = await res.json();
    if (data?.status) toast.success(data?.message);
    else toast.error(data?.message);
    return data;
  } catch (e) {
    toast.error(e.message);
    return { status: false, message: e.message };
  }
}

export async function event_destroy(id, branchId) {
  try {
    const res = await fetch(`${base}/event-destroy?id=${id}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ branch_id: branchId }),
    });
    const data = await res.json();
    if (data?.status) toast.success(data?.message);
    else toast.error(data?.message);
    return data;
  } catch (e) {
    toast.error(e.message);
    return { status: false, message: e.message };
  }
}

export async function event_course_options(branchId) {
  try {
    const res = await fetch(`${base}/event-course-options?branch_id=${branchId}`);
    return await res.json();
  } catch (e) {
    return { status: false, data: { grades: [], courses: [] } };
  }
}

// Active assessments from Test Management. Branches pick one when
// scheduling a Test on the calendar. The TSTM GUID is hidden from this
// payload — backend resolves it from test_type.id at save time.
export async function test_types_for_branch() {
  try {
    const res = await fetch(`${base}/test-types`);
    return await res.json();
  } catch (e) {
    return { status: false, data: [] };
  }
}
